module.exports = __webpack_public_path__ + "static/media/logout.ce58d243.svg";